<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-02-22 14:23:53
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-24 13:16:00
 -->
<template>
  <div :class="['the-header', bk && 'bk-img']">
    <!-- <the-header-nav /> -->
    <the-header-tab v-if="$route.path === '/home'" />
    <span class="title" @click="handleClickgoMode">道路安全监测管理系统</span>
    <the-header-dropdown />
    <!-- <the-header-notice style="float: right;margin: 22px 40px 0 0;" /> -->
  </div>
</template>

<script>
import { state } from 'vue-function-api'

import { mapState, mapActions } from 'vuex'

// import TheHeaderNav from './TheHeaderNav'
// import TheHeaderNotice from './TheHeaderNotice'
import TheHeaderDropdown from './TheHeaderDropdown'
import TheHeaderTab from './TheHeaderTab'

export default {
  name: 'TheHeader',
  components: {
    // TheHeaderNav,
    // TheHeaderNotice,
    TheHeaderDropdown,
    TheHeaderTab,
  },
  props: {
    bk: {
      type: Boolean,
      default: true,
    },
  },
  computed: mapState(['realname']),
  methods: {
    ...mapActions(['pageLogout']),
    handleClickgoMode () {
      // bk为true表示当前页面是大屏模式，需要跳转到管理模式
      let path = this.bk ? '/manaMode' : '/'
      this.$router.push({ path })
    },
  },
  setup () {
    const data = state({
      active: 0,
    })

    return {
      ...data,
    }
  },
}
</script>

<style lang="less" scoped>
.the-header {
  min-width: 1200px;
  height: 60px;
  position: relative;
  font-size: 16px;
  color: #ffffff;
  background-color: #021528;
  text-align: center;

  .title {
    line-height: 55px;
    font-size: 28px;
    font-weight: bold;
    // margin-left: 160px;
    background-image: linear-gradient(to right, #87cefe, #e3f7ff, #87cefe);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    cursor: pointer;
  }
}

.bk-img {
  height: 70px;
  background: #021528 url('/static/img/common/header.png') no-repeat;
  background-size: 100% 98%;

  .title {
    transform: translate(-50%, -70%);
  }
}
</style>
